import './Card.scss'
import TaskDetails from '../../../components/TaskDetails'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import AssigneeList from './AssigneeList'
import classNames from 'classnames'
import { isGeneratedId } from '../../../store/addTask'
import { CARDTYPE_STANDARD, CARDTYPE_PREVIEW } from '../../../constants/cardConstants'

class Card extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      detailsOpen: false,
      isMouseOver: false
    }
  }

  openTaskDetailsModal = () => {
    if (!isGeneratedId(this.props.task.id)) {
      this.setState({ detailsOpen: true })
    }
  }

  closeTaskDetailsModal = () => {
    this.setState({ detailsOpen: false })
  }

  render() {
    const { task, cardType } = this.props
    const cardClasses = classNames({
      card: true,
      preview: cardType === CARDTYPE_PREVIEW,
      notdraggable: this.props.notDraggable,
      'card--hover': this.state.isMouseOver  // :hover css doesnt remove itself in chrome for mac on drag
    })
    return <div>
      <div className={cardClasses}
        onClick={this.openTaskDetailsModal}
        onMouseOver={() => this.setState({ isMouseOver: true })}
        onMouseOut={() => this.setState({ isMouseOver: false })} >
        {task.name}
        {task.assignments.length > 0 &&
          <AssigneeList assignments={task.assignments} />
        }
      </div>
      {this.state.detailsOpen &&
        <TaskDetails
          modalOpen
          onClose={this.closeTaskDetailsModal}
          task={task} />
      }
    </div>
  }
}

Card.defaultProps = {
  cardType: CARDTYPE_STANDARD
}

Card.propTypes = {
  task: PropTypes.object.isRequired,
  cardType: PropTypes.string.isRequired,
  notDraggable: PropTypes.bool
}

export default Card



// WEBPACK FOOTER //
// ./src/routes/Board/components/Card.js